export const S3_URL = (p = '') => `${process.env.REACT_APP_S3_BUCKET_DOMAIN || ''}${p || ''}`;

export const CURRENCY_CONFIG = {
  kr: { standardKey: 'krw', apiKey: 'krw', vipKey: 'vip_krw_price', symbol: '₩', label: '원화' },
  en: { standardKey: 'usd', apiKey: 'usd', vipKey: 'vip_usd_price', symbol: '$', label: 'USD' },
  ur: { standardKey: 'eur', apiKey: 'euro', vipKey: 'vip_eur_price', symbol: '€', label: 'EUR' },
  jp: { standardKey: 'usd', apiKey: 'usd', vipKey: 'vip_usd_price', symbol: '$', label: 'USD' }, // 일본은 DCC 를 이용해서 달러를 엔화를 결정해서
};

// export const CURRENCY_CONFIG = {
//   kr: { standardKey: 'krw', apiKey: 'krw', vipKey: 'vip_krw_price', symbol: '₩', label: '원화' },
//   en: { standardKey: 'usd', apiKey: 'usd', vipKey: 'vip_usd_price', symbol: '$', label: 'USD' },
//   ur: { standardKey: 'eur', apiKey: 'euro', vipKey: 'vip_eur_price', symbol: '€', label: 'EUR' },
//   jp: { standardKey: 'jpy', apiKey: 'jpy', vipKey: 'vip_jpy_price', symbol: '¥', label: 'JPY' },
// };
